import type { UpdatePaymentRequest } from '../../../generated-types';
import nullableZonedDateToUtc from '../../../utils/mapper/nullableZonedDateToUtc';
import { TransferState } from '../../transaction/Transfer/form/state';

export default () =>
    (transferState: TransferState): UpdatePaymentRequest => ({
        paymentType: 'TRANSFER',
        amount: transferState.amount || 0,
        currency: 'NOK',
        fromAccountNumber: transferState.fromAccount!,
        paymentDate: nullableZonedDateToUtc(transferState.transferDate)!,
        toAccount: transferState.toAccount!,
        text: transferState.note,
        ownText: transferState.ownText || transferState.note,
        deviceId: window.ReactNativeProps?.deviceId,
    });
